// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ybTm","col":"styles_col__29aCK"};